import React, { Fragment } from 'react';
import { get } from 'mori';
import App from 'common/backbone-app';
import moment from 'common/moment';
import OverviewCustomerSection from './overview-customer-section';
import { getByType } from '../utils';

type OverviewProps = {
  data?: {};
  lang: {
    walkInClient: string;
    transactionLabel: string;
    dateLabel: string;
    checkoutOutLabel: string;
    transactionLabelPosLite: string;
  };
  isCancellation?: boolean;
};
const Overview: React.SFC<OverviewProps> = ({ isCancellation, data, lang }) => {
  const isRefund = isCancellation === true;
  const info = get(data, getByType(isRefund, 'checkoutInformation', 'cancellationInformation'));
  const getData = (ifCheckout, ifRefund = ifCheckout) =>
    get(info, getByType(isRefund, ifCheckout, ifRefund));
  const dateTime = moment(getData('created')).tz(App.getTimezone()).formatFullDateTime();
  return (
    <div className="overview-summary">
      <div className="left">
        <span className="transaction-id">
          {App.config.get('venue').pointOfSaleEnabled ? (
            <Fragment>
              {lang.transactionLabel}
              {getData('transactionIdForDisplay', 'transactionId')}
            </Fragment>
          ) : (
            lang.transactionLabelPosLite
          )}
        </span>
        <span className="overview-row">
          <span className="date-label">{lang.dateLabel}</span>
          <span className="date">{dateTime}</span>
        </span>
        <span className="overview-row">
          <span className="employee-label">{lang.checkoutOutLabel}</span>
          <span className="employee-name">{get(info, 'employeeName')}</span>
        </span>
      </div>
      <OverviewCustomerSection
        walkInLabel={lang.walkInClient}
        customerName={getData('venueCustomerName')}
        phone={get(data, 'phone')}
        emailAddress={get(data, 'emailAddress')}
      />
    </div>
  );
};
Overview.defaultProps = {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type '{} | undefi... Remove this comment to see the full error message
  data: null,
  isCancellation: false,
};

export default Overview;
